import { Directive, ElementRef, inject } from '@angular/core';

import { PostRenderCleanupServiceToken } from '../services/post-render-cleanup.service';

@Directive({
  selector: '[emailSsrMarkToUnwrap]',
  standalone: true,
})
export class SsrMarkToUnwrapDirective {
  public svc = inject(PostRenderCleanupServiceToken);
  public elRef = inject(ElementRef);

  public ngOnInit() {
    this.svc.register(this.elRef.nativeElement);
  }
}
